"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allCountries = exports.allMarkets = void 0;
const basic_types_1 = require("../constants/generated/basic-types");
const markets_1 = require("../constants/generated/markets");
exports.allMarkets = (0, markets_1.getAllMarkets)();
const marketsByBrand = Object.values(basic_types_1.Brand).map((brand) => exports.allMarkets[brand]);
const flattened = [].concat(...marketsByBrand);
exports.allCountries = flattened.reduce(function (acc, market) {
    if (acc.map((country) => country.iso2).includes(market === null || market === void 0 ? void 0 : market.country.iso2)) {
        return acc;
    }
    return [...acc, market === null || market === void 0 ? void 0 : market.country];
}, []);
